import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#003554',       // --deep
      dark: '#00263d',       // --deep-dark
      light: '#dceef1',      // --pacific-lt
    },
    secondary: {
      main: '#61A0AF',       // --pacific
      light: '#dceef1',
    },
    warning: {
      main: '#AF9164',       // --camel
      light: '#f0ede8',
    },
    error: {
      main: '#753742',       // --plum
      light: '#f5e8ea',
    },
    info: {
      main: '#4D4730',       // --khaki
      light: '#edeae4',
    },
    background: {
      default: '#f5f2ee',    // --bg
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a',    // --text
      secondary: '#4D4730',  // --khaki (muted)
    },
    divider: '#e0dbd4',      // --border
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: { fontSize: '20px', fontWeight: 700, color: '#003554' },
    h2: { fontSize: '16px', fontWeight: 700, color: '#003554' },
    h3: { fontSize: '14px', fontWeight: 600, color: '#003554' },
    subtitle1: { fontSize: '13px', color: '#4D4730' },
    subtitle2: { fontSize: '11px', textTransform: 'uppercase' as const, letterSpacing: '0.5px', color: '#4D4730', fontWeight: 600 },
    body1: { fontSize: '13px', color: '#1a1a1a' },
    body2: { fontSize: '12px', color: '#4D4730' },
    caption: { fontSize: '10px', textTransform: 'uppercase' as const, letterSpacing: '0.4px', color: '#4D4730' },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '13px',
          borderRadius: 6,
          padding: '8px 16px',
        },
        containedPrimary: {
          '&:hover': { opacity: 0.9 },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontWeight: 500,
          fontSize: '12px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          border: '1px solid rgba(0,53,84,0.08)',
          boxShadow: 'none',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontSize: '11px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            color: '#4D4730',
            fontWeight: 600,
            background: 'rgba(0,53,84,0.03)',
            borderBottom: '2px solid rgba(0,53,84,0.08)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          padding: '12px 14px',
          borderBottom: '1px solid rgba(0,53,84,0.05)',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          '&:hover td': {
            background: 'rgba(97,160,175,0.1)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            fontSize: '13px',
            borderRadius: 6,
            '& fieldset': {
              borderColor: 'rgba(0,53,84,0.12)',
            },
            '&:hover fieldset': {
              borderColor: '#61A0AF',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#61A0AF',
            },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
